var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M11.0837 2.75322C11.0837 2.15291 10.597 1.66626 9.99674 1.66626C9.39643 1.66626 8.90978 2.15291 8.90978 2.75322V8.91263H2.75036C2.15005 8.91263 1.66341 9.39928 1.66341 9.99959C1.66341 10.5999 2.15005 11.0865 2.75036 11.0865H8.90978V17.246C8.90978 17.8463 9.39643 18.3329 9.99674 18.3329C10.597 18.3329 11.0837 17.8463 11.0837 17.246V11.0865H17.2431C17.8434 11.0865 18.3301 10.5999 18.3301 9.99959C18.3301 9.39928 17.8434 8.91264 17.2431 8.91264H11.0837V2.75322Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_891_2159)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Fill",
  width: 20,
  height: 20,
  fill: "white"
}));

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_891_2159",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _ref2), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.708e3c25.svg";
export { ForwardRef as ReactComponent };